import { useState } from "react";
import { Select } from "antd";
import { useNavigate } from "react-router-dom";
import { AxiosError } from "axios";
import api from "../../services/api";

const DispatcherProfile = () => {
  const [form, setForm] = useState({
    office_location: "",
    assigned_region: "",
    shift_hours: "9AM-5PM",
    contact_name: "",
    contact_phone: "",
    contact_email: "",
  });
  const [error, setError] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState(false);

  const navigate = useNavigate();

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setError(null);
    setIsLoading(true);

    const token = localStorage.getItem("token");
    if (!token) {
      setError("You are not logged in. Please log in and try again.");
      setIsLoading(false);
      return;
    }

    try {
      await api.post("/profile/complete-profile/dispatcher", form);
      navigate("/dashboard");
    } catch (err) {
      const axiosErr = err as AxiosError<{ message?: string }>;
      setError(
        axiosErr.response?.data?.message ||
          "Network error. Please check your connection and try again.",
      );
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-4 max-w-md mx-auto p-6">
      <h2 className="text-2xl font-bold">Complete Dispatcher Profile</h2>

      <div aria-live="polite" aria-atomic="true">
        {error && (
          <div className="p-3 bg-red-50 border border-red-200 rounded-lg">
            <p className="text-sm text-red-600">{error}</p>
          </div>
        )}
      </div>

      <div>
        <label htmlFor="office_location" className="block text-sm font-medium text-gray-700 mb-1">Office Location</label>
        <input id="office_location" type="text" name="office_location" placeholder="Enter office location\u2026" onChange={handleChange} className="w-full border rounded px-3 py-2" />
      </div>
      <div>
        <label htmlFor="assigned_region" className="block text-sm font-medium text-gray-700 mb-1">Assigned Region</label>
        <input id="assigned_region" type="text" name="assigned_region" placeholder="Enter assigned region\u2026" onChange={handleChange} className="w-full border rounded px-3 py-2" />
      </div>
      <div>
        <label htmlFor="shift_hours" className="block text-sm font-medium text-gray-700 mb-1">Shift Hours</label>
        <Select id="shift_hours" onChange={(v) => setForm({ ...form, shift_hours: v })} value={form.shift_hours} style={{ width: '100%' }}>
          <Select.Option value="9AM-5PM">9 AM \u2013 5 PM</Select.Option>
          <Select.Option value="10AM-6PM">10 AM \u2013 6 PM</Select.Option>
          <Select.Option value="11AM-7PM">11 AM \u2013 7 PM</Select.Option>
        </Select>
      </div>
      <div>
        <label htmlFor="contact_name" className="block text-sm font-medium text-gray-700 mb-1">Contact Name</label>
        <input id="contact_name" type="text" name="contact_name" autoComplete="name" placeholder="Enter contact name\u2026" onChange={handleChange} className="w-full border rounded px-3 py-2" />
      </div>
      <div>
        <label htmlFor="contact_phone" className="block text-sm font-medium text-gray-700 mb-1">Contact Phone</label>
        <input id="contact_phone" type="tel" name="contact_phone" autoComplete="tel" placeholder="Enter contact phone\u2026" onChange={handleChange} className="w-full border rounded px-3 py-2" />
      </div>
      <div>
        <label htmlFor="contact_email" className="block text-sm font-medium text-gray-700 mb-1">Contact Email</label>
        <input id="contact_email" type="email" name="contact_email" autoComplete="email" spellCheck={false} placeholder="Enter contact email\u2026" onChange={handleChange} className="w-full border rounded px-3 py-2" />
      </div>
      <button type="submit" disabled={isLoading} className="w-full bg-green-600 text-white py-2 rounded hover:bg-green-700 disabled:opacity-50">
        {isLoading ? "Submitting\u2026" : "Submit"}
      </button>
    </form>
  );
};

export default DispatcherProfile;
